
///
/// Disabled Elements
///
/// Add a tabindex of -1 to all disabled elements
/// so that focus cannot be passed to the element 

window.SetUpDisabledElements = function() {

	var disabledElements = document.querySelectorAll('.disabled');

	for (var i = 0; i < disabledElements.length; i++) {

		var disabledElement = disabledElements[i];

		disabledElement.setAttribute('tabindex', '-1');
	}
}

if (document.readyState !== 'loading') {
	window.SetUpDisabledElements();
} else {
	document.addEventListener('DOMContentLoaded', function () {
		window.SetUpDisabledElements();
	});
}